// extracted by mini-css-extract-plugin
export default {"InfoList":"InfoList_InfoList__SSynl","Item":"InfoList_Item__8px7f","Picto":"InfoList_Picto__TyRgm","Text":"InfoList_Text__CAlfh"};